import { create } from "zustand";
import { useAmlCheckStore } from "./useAmlCheckStore";
import { MODE_FLOAT, MODE_INLINE, THEME_LIGHT, THEME_DARK } from "@/config";

interface WidgetConfig {
  theme: typeof THEME_LIGHT | typeof THEME_DARK;
  widgetMode: typeof MODE_FLOAT | typeof MODE_INLINE;
}

interface ConfigStore {
  // State
  parentOrigin: string | null;
  appId: string | null;
  externalId: string | null;
  username: string | null;
  config: WidgetConfig;
  isOpen: boolean;

  // Actions
  setInitParams: (params: {
    parentOrigin: string | null;
    appId: string | null;
  }) => void;
  setExternalId: (externalId: string | null) => void;
  setUsername: (username: string | null) => void;
  setWidgetConfig: (config: WidgetConfig) => void;
  resetStore: () => void;
  setIsOpen: (isOpen: boolean) => void;
}

export const useConfigStore = create<ConfigStore>((set) => ({
  // Initial State
  parentOrigin: null,
  appId: null,
  externalId: null,
  username: null,
  isOpen: false,
  config: { theme: THEME_LIGHT, widgetMode: MODE_FLOAT },

  // Actions implementation
  setIsOpen: (isOpen) => set({ isOpen }),
  setInitParams: (params) => set({ ...params }),
  setExternalId: (externalId) => set({ externalId }),
  setUsername: (username) => set({ username }),

  setWidgetConfig: (config) =>
    set((state) => ({
      config: { ...state.config, ...config },
    })),

  resetStore: () => {
    const { clearExternalData } = useAmlCheckStore.getState();

    set({
      parentOrigin: null,
      appId: null,
      externalId: null,
      isOpen: false,
      config: { theme: THEME_LIGHT, widgetMode: MODE_FLOAT },
    });

    clearExternalData();
  },
}));
